import React from 'react';
import { Calendar, Clock, MapPin, Coffee, Book, Users, Heart } from 'lucide-react';

const ServiceTimes = () => {
  const weeklySchedule = [
    {
      day: 'Sunday',
      icon: Users,
      services: [
        {
          name: 'Meet & Greet',
          time: '4:30 PM - 5:00 PM',
          description: 'Welcome and fellowship time before service'
        },
        {
          name: 'Worship Service',
          time: '5:00 PM - 6:30 PM',
          description: 'Expository preaching and authentic worship following Acts 2:42'
        },
        {
          name: 'Sunday School',
          time: '5:30 PM',
          description: 'Biblical teaching for all ages'
        },
        {
          name: 'Fellowship Meal',
          time: 'After Service',
          description: 'Join us for a meal and fellowship after the service'
        }
      ]
    },
    {
      day: 'Monday',
      icon: Heart,
      services: [
        {
          name: 'Online Devotion',
          time: '7:00 PM (15 minutes)',
          description: 'Quick online devotional time to start the week'
        }
      ]
    },
    {
      day: 'Wednesday',
      icon: Heart,
      services: [
        {
          name: 'Prayer Meeting',
          time: '7:00 PM - 8:00 PM',
          description: 'Corporate prayer and intercession'
        }
      ]
    },
    {
      day: 'Saturday',
      icon: Book,
      services: [
        {
          name: 'Bible Study',
          time: '7:00 PM - 8:00 PM',
          description: 'Deep dive into God\'s Word together'
        }
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Join Us for Worship
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Come experience authentic worship and biblical teaching
          </p>
        </div>

        {/* Location Card */}
        <div className="bg-gradient-to-br from-[#f17b21] to-orange-600 rounded-2xl shadow-xl p-8 mb-12 max-w-3xl mx-auto text-white">
          <div className="flex items-start space-x-4">
            <MapPin className="w-8 h-8 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-2xl font-bold mb-2">Our Location</h3>
              <p className="text-lg mb-1">Grand Prairie, TX area</p>
              <p className="text-sm text-white/90 mb-3">We currently gather in a home setting for intimate worship. For the privacy of our host family, we share our address directly with visitors.</p>
              <a 
                href="/visit"
                className="inline-flex items-center text-white hover:text-orange-100 underline transition-colors"
              >
                Request location details →
              </a>
            </div>
          </div>
        </div>

        {/* Weekly Schedule */}
        <div className="max-w-6xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">Weekly Schedule</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {weeklySchedule.map((schedule, index) => {
              const Icon = schedule.icon;
              return (
                <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
                  <div className="flex items-center mb-4">
                    <Icon className="w-6 h-6 text-[#f17b21] mr-2" />
                    <h4 className="text-xl font-bold text-gray-800">{schedule.day}</h4>
                  </div>
                  <div className="space-y-4">
                    {schedule.services.map((service, idx) => (
                      <div key={idx} className="border-l-2 border-[#f17b21] pl-3">
                        <p className="font-semibold text-gray-800 text-sm">{service.name}</p>
                        <p className="text-[#f17b21] font-bold text-sm mb-1">{service.time}</p>
                        <p className="text-gray-600 text-xs">{service.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Quick Info */}
        <div className="mt-12 flex flex-col items-center space-y-4">
          <div className="inline-flex items-center space-x-2 bg-white px-6 py-3 rounded-full shadow-md">
            <Coffee className="w-5 h-5 text-[#f17b21]" />
            <span className="text-gray-700 font-medium">Meal served every Sunday after service</span>
          </div>
          <p className="text-sm text-gray-500">
            Can't join us in person?{' '}
            <a 
              href="https://elbethel.online" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#f17b21] hover:text-[#d86919] underline"
            >
              Visit our online ministry
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceTimes;